<template>
  <div id="modalOrderPackage" class="modal fade">
    <div
      class="modal-dialog modal-dialog-vertical-center modal-lg"
      role="document"
    >
      <div class="modal-content bd-0 tx-14">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("order.发货明细") }}
          </h6>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-25">
          <form class="trackForm">
            <div
              v-for="(info, index) in items"
              :key="index"
              :data-track="info.expressCode"
              class="row track-wrap"
              :class="expressCode == info.expressCode ? 'selected' : ''"
            >
              <div
                class="
                  track-head
                  d-flex
                  align-items-center
                  pd-x-15 pd-y-8
                  justify-content-between
                  col-12
                  mg-x-0
                  pd-0
                "
              >
                <strong class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold"
                  >{{ $t("order.包裹") }}{{ index + 1 }}</strong
                >
              </div>
              <p class="col-12 mg-y-5">
                <span class="mg-r-20">
                  {{ $t("order.快递渠道：") }}
                  <span class="tx-black tx-normal">{{ info.companyName }}</span>
                </span>
                <span class="mg-r-10">
                  {{ $t("order.快递单号：") }}
                  <a
                    v-if="info.expressCode"
                    class="tx-underline tx-info"
                    href="javascript:;"
                    >{{ info.expressCode }}</a
                  >
                  <a
                    href="javascript:;"
                    :data-clipboard-text="info.expressCode"
                    class="to-clipboard"
                  >
                    <i class="icon ion-clipboard tx-black"></i>
                  </a>
                </span>
                <a
                  v-show="!(params[index] || {}).active && info.isReceived != 1"
                  class="tx-info tx-underline"
                  href="javascript:;"
                  @click="activeEdit(index)"
                >
                  {{ $t("order.修改物流信息") }}
                </a>
              </p>
              <p class="col-12 mg-b-5">
                <span class="mg-r-20">
                  {{ $t("order.运费：") }}
                  <span class="tx-black tx-normal">{{
                    info.shippingAmount || 0
                  }}</span>
                </span>
                <span class="mg-r-10">
                  {{ $t("order.发货时间：") }}
                  <span class="tx-black tx-normal">
                    {{ info.deliverTime || "----" }}
                  </span>
                </span>
              </p>
              <div
                v-show="(params[index] || {}).active"
                class="
                  wd-100p
                  form-group
                  row
                  pd-x-20
                  mg-b-10
                  align-items-center
                "
              >
                <div
                  class="col-6 d-flex align-items-center"
                  v-if="info.deliveryType == 1"
                >
                  <span class="col-form-label form-control-sm mg-r-5 col-4"
                    >{{ $t("other.物流公司") }}：</span
                  >
                  <div>
                    <input
                      class="form-control form-control-sm"
                      name="companyName"
                      type="text"
                      v-model.trim="(params[index] || {}).companyName"
                    />
                  </div>
                </div>
                <div class="col-6 d-flex align-items-center">
                  <label class="col-form-label form-control-sm mg-r-5 col-4">{{
                    $t("order.运单号：")
                  }}</label>
                  <div>
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      name="trackNumber"
                      :id="'trackNumber' + index"
                      v-model.trim="(params[index] || {}).updateExpressCode"
                    />
                  </div>
                </div>
                <div
                  class="col-6 d-flex align-items-center"
                  v-if="info.deliveryType != 2"
                >
                  <label class="col-form-label form-control-sm mg-r-5 col-4">{{
                    $t("order.费用：")
                  }}</label>
                  <div>
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      name="shippingAmount"
                      v-model.number="(params[index] || {}).shippingAmount"
                      @keyup="changeAmount(index)"
                      @change="changeAmount(index)"
                    />
                  </div>
                </div>
                <div class="col-6 d-flex align-items-center">
                  <div class="col-form-label form-control-sm">
                    <a
                      class="btn btn-sm btn-info"
                      href="javascript:;"
                      @click="saveEdit(index)"
                      >{{ $t("order.保存") }}</a
                    >
                    <a
                      class="btn btn-sm btn-secondary"
                      href="javascript:;"
                      @click="canelActiveEdit(index)"
                      >{{ $t("order.取消") }}</a
                    >
                  </div>
                </div>
              </div>
              <div
                v-if="info.productInfo && info.productInfo.length > 0"
                class="d-flex mg-b-5 col-12"
              >
                <div>{{ $t("order.内含商品：") }}</div>
                <div>
                  <p
                    v-for="product in info.productInfo"
                    :key="product.supplierProductStockId"
                    class="mg-b-5"
                  >
                    <span class="mg-r-20">
                      sku：
                      <span class="tx-black tx-normal"
                        >{{ product.sku }}
                        <a
                          href="javascript:;"
                          :data-clipboard-text="product.sku"
                          class="to-clipboard"
                        >
                          <i class="icon ion-clipboard tx-black"></i>
                        </a>
                      </span>
                    </span>
                    <span>
                      {{ $t("distributor.已发：") }}
                      <span class="tx-black tx-normal">{{
                        product.deliveryCnt
                      }}</span>
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="
              btn btn-secondary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            data-dismiss="modal"
          >
            {{ $t("order.关闭") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    code: String,
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    expressCode: String,
  },
  data() {
    return {
      params: [],
    };
  },
  watch: {
    items() {
      this.params = [];
      (this.items || []).forEach((e) => {
        this.params.push({
          active: false,
          expressCode: e.expressCode,
          updateExpressCode: e.expressCode,
          shippingAmount: e.shippingAmount,
          companyName: e.companyName,
        });
      });
    },
  },
  mounted() {
    $("#modalOrderPackage").on("hidden.bs.modal", (e) => {
      this.$parent.orderItem = {};
      this.$parent.modalTrackNumber = [];
      this.$parent.modalTrackExpressCode = "";
      this.params = [];
    });
    let vm = this;
    $("#modalOrderPackage .modal-body").scrollTop(0);
    $("#modalOrderPackage").on("shown.bs.modal", () => {
      if ($("#modalOrderPackage .modal-body").height() >= 350) {
        if (!vm.expressCode) return;
        $("#modalOrderPackage .modal-body").scrollTop(
          $(`[data-track=${vm.expressCode}]`).offset().top -
            $("#modalOrderPackage .modal-body").offset().top -
            $(`[data-track=${vm.expressCode}]`).height()
        );
      }
    });
  },
  methods: {
    // 限制输入的字符必须是数字和小数点
    changeAmount(i) {
      if (
        this.params[i].shippingAmount != "" &&
        this.params[i].shippingAmount.toString().indexOf(".") != -1 &&
        this.params[i].shippingAmount.toString().split(".").length > 1 &&
        this.params[i].shippingAmount.toString().split(".")[1].length > 2
      ) {
        this.params[i].shippingAmount =
          Math.floor(this.params[i].shippingAmount * 100) / 100
            ? Math.floor(this.params[i].shippingAmount * 100) / 100
            : 0;
      }
    },
    // 显示修改包裹信息输入框
    activeEdit(i) {
      this.params[i].active = true;
    },
    // 取消编辑的时候恢复初始值
    canelActiveEdit(i) {
      this.params[i].active = false;
      this.params[i].shippingAmount = this.items[i].shippingAmount;
      this.params[i].expressCode = this.items[i].expressCode;
      this.params[i].companyName = this.items[i].companyName;
    },
    // 保存修改的包裹信息
    saveEdit(i) {
      if (this.items[i].deliveryType == 1) {
        if (!this.params[i].companyName)
          return ShowTip(this.$t("outside.请输入物流公司名称"), "danger");
        if (!this.params[i].expressCode)
          return ShowTip(this.$t("order.请输入一个运单号"), "danger");
      } else if (
        this.items[i].deliveryType == 2 ||
        this.items[i].deliveryType == 3
      ) {
        if (!this.params[i].expressCode)
          return ShowTip(this.$t("order.请输入一个运单号"), "danger");
      }
      this.$parent.loading = true;
      let params = {
        code: this.code,
        expressCode: this.params[i].expressCode,
        updateExpressCode: this.params[i].updateExpressCode,
        companyName: this.params[i].companyName,
        shippingAmount: this.params[i].shippingAmount,
      };
      $.api_call(
        "api.SupplierPurchaseOrder.modifyShippingInfo",
        params,
        (r) => {
          this.$parent.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("mall.修改成功"), "success");
            $("#modalOrderPackage").modal("hide");
            setTimeout(() => {
              this.$parent.getRMOrder(true);
            }, 1000);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
  },
};
</script>

<style scoped>
.row {
  margin-bottom: 15px;
}
.row:last-child {
  border-bottom: none;
  margin-bottom: 0;
}
.track-wrap {
  background: #f6f6f6;
}
.track-head {
  border-bottom: 1px solid #ddd;
}
.track-wrap.selected {
  background: #ddd;
}
.track-wrap.selected {
  border: 3px solid #17a2b8;
}
</style>